import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, includeDeleted = false) {
  return apiFetch({
    endPoint: `InsuranceCarrier?organizedUnitId=${organizedUnitId}&includeDeleted=${includeDeleted}`,
    method: 'GET',
    body: null,
    token: token
  })
}
